import { DownTimeStore } from "stores/DownTimeStore";
import { ManageElement } from "./ManageElement";

export class DownTime extends ManageElement {
  static _store: DownTimeStore;
}
